import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// Types
import Reducers from "app/types/Reducers";

interface IState {
  columns: string;
  compare: string[];
  gridResizer: number;

  showRecordsSidebar: boolean;

  // ToDO
  workspaceType: 'pages' | 'episodes';
};

const initialState:IState = {
  columns: 'columns_auto',
  compare: [],
  gridResizer: 70,

  showRecordsSidebar: true,

  // ToDO
  workspaceType: 'pages'
};

const slice = createSlice({
  name: Reducers.Ui,
  initialState,
  reducers: {
    setColumns: (state, action:PayloadAction<string>) => {
      state.columns = action.payload;
    },
    addToCompare: (state, action:PayloadAction<string>) => {
      state.compare = [...state.compare, action.payload];
    },
    removeFromCompare: (state, action:PayloadAction<string>) => {
      state.compare = state.compare.filter((item:string) => item !== action.payload);
    },
    toggleRecordsSidebar: (state) => {
      state.showRecordsSidebar = !state.showRecordsSidebar;
    },

    setInitial: <IStateKey extends keyof IState>(state:IState, action:PayloadAction<IStateKey>) => {
      state[action.payload] = initialState[action.payload];
    },

    // ToDO
    setWorkspaceType: (state, action:PayloadAction<'pages' | 'episodes'>) => {
      console.log(action.payload);
      state.workspaceType = action.payload;
    }
  }
});

export const {
  setColumns,
  addToCompare, removeFromCompare,
  toggleRecordsSidebar,
  setInitial,
  // ToDO
  setWorkspaceType
} = slice.actions;

export default slice.reducer;
